import {GenReport} from '../../../generated/serverModels/GenReport';

export class Report extends GenReport {
  public groupIcon: string;

  constructor(report?: Report) {
    super(report);
  }
}
